"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIUtils = void 0;
const path = __importStar(require("path"));
const StringSeparator_1 = require("../../enums/StringSeparator");
class CLIUtils {
    static getUserConfig(configPath) {
        let config;
        const configFileExtension = path.extname(configPath);
        const isValidExtension = CLIUtils.allowedConfigFileExtensions.includes(configFileExtension);
        if (!isValidExtension) {
            throw new ReferenceError('Given config path must be a valid `.js|.mjs|.cjs` or `.json` file path');
        }
        try {
            config = require(configPath);
        }
        catch (_a) {
            try {
                config = __non_webpack_require__(configPath);
            }
            catch (_b) {
                throw new ReferenceError(`Cannot open config file with path: ${configPath}`);
            }
        }
        return config;
    }
    static stringifyOptionAvailableValues(optionEnum) {
        return Object.values(optionEnum).join(`${StringSeparator_1.StringSeparator.Comma} `);
    }
}
exports.CLIUtils = CLIUtils;
CLIUtils.allowedConfigFileExtensions = [
    '.js',
    '.json',
    '.cjs'
];
